<script>
export default {
  name: 'Settings',
  props: {
    component: { type: Object, default: () => Object() }
  }
}
</script>

<template>
<div class='d-flex flex-column flex-grow-1'>
  <div v-for='(setting, k) in component.settings' :key='k'
    class='flex-grow-1'>
    <div v-html='setting.label' class='mt-2 body-1 font-weight-medium'/>
    <candela-settings-control :setting='setting' :id='k'
      :component_id='component.id'/>
  </div>
</div>
</template>
